import type { PublicConsultationType } from '../models/public-consultation-type';
import { usePublicSiteData } from './use-public-site-data';

interface ConsultationTypesState {
    types: readonly PublicConsultationType[];

    /** Nothing to show yet, and an answer is still coming. */
    loading: boolean;
}

/** The services the booking wizard offers, present on the first render when the page carried them. */
export function useConsultationTypes(): ConsultationTypesState {
    const { data, settled } = usePublicSiteData();

    return {
        types: data.consultationTypes,
        loading: !settled && data.consultationTypes.length === 0
    };
}
